module.exports = __webpack_public_path__ + "img/about-3.40ef089.jpg";